import React from "react";
import { IoCalendar } from "react-icons/io5";
import { MdExpandMore } from "react-icons/md";
import { useTranslation } from "react-i18next";
import EASkeletonLoader from "../../../shared/EASkeletonLoader";
import useReservationsList from "./useReservationsList";
import SingleReservation from "./SingleReservation";
import EAButton from "../../../shared/Buttons/EAButton";
import EmptyStateContainer from "./EmptyStateContainer";

const ReservationsList = () => {
  const { t } = useTranslation();
  const {
    upcomingReservations,
    pastReservations,
    loading,
    showPastReservation,
    setShowPastReservation,
    refreshTickets,
    displayedUpcomingCount,
    setDisplayedUpcomingCount,
    displayedPastCount,
    setDisplayedPastCount,
    ITEMS_PER_PAGE,
  } = useReservationsList();

  if (loading) {
    return <EASkeletonLoader height="120px" />;
  }

  return (
    <div className="list-container">
      <span className="text-size-body-large text-color-primary text-icon-align-center">
        <IoCalendar /> <b>{t("nadchodzące")}</b>
      </span>
      <div className="list-wrapper">
        {upcomingReservations.length > 0 ? (
          <>
            {upcomingReservations.slice(0, displayedUpcomingCount).map((reservation, index) => (
              <SingleReservation
                key={index}
                ticket={reservation.ticket}
                exercise={reservation.exercise}
                onRefreshTickets={refreshTickets}
              />
            ))}
            {displayedUpcomingCount < upcomingReservations.length && (
              <div style={{ display: "flex", justifyContent: "center", marginTop: "16px" }}>
                <EAButton
                  title={t("pokaz_wiecej")}
                  variant="outlined"
                  endIcon={<MdExpandMore />}
                  onClick={() => setDisplayedUpcomingCount(displayedUpcomingCount + ITEMS_PER_PAGE)}
                />
              </div>
            )}
          </>
        ) : (
          <EmptyStateContainer />
        )}
      </div>

      <span className="text-size-body-large text-color-dark-gray text-icon-align-center">
        <IoCalendar /> <b>{t("przeszłe")}</b>
      </span>
      {showPastReservation ? (
        <div className="list-wrapper">
          {pastReservations.length > 0 ? (
            <>
              {pastReservations.slice(0, displayedPastCount).map((reservation, index) => (
                <SingleReservation
                  key={index}
                  ticket={reservation.ticket}
                  exercise={reservation.exercise}
                  onRefreshTickets={refreshTickets}
                />
              ))}
              {displayedPastCount < pastReservations.length && (
                <div style={{ display: "flex", justifyContent: "center", marginTop: "16px" }}>
                  <EAButton
                    title={t("pokaz_starsze")}
                    variant="outlined"
                    endIcon={<MdExpandMore />}
                    onClick={() => setDisplayedPastCount(displayedPastCount + ITEMS_PER_PAGE)}
                  />
                </div>
              )}
            </>
          ) : (
            <p style={{ textAlign: "center", color: "var(--primary-color500)" }}>{t("brak_przeszlych_rezerwacji")}</p>
          )}
        </div>
      ) : (
        <EAButton
          title={t("Pokaż historię rezerwacji")}
          variant="text"
          color="primary"
          onClick={() => setShowPastReservation(!showPastReservation)}
        />
      )}
    </div>
  );
};

export default ReservationsList;
